import CryptoJS from 'crypto-js'
import { ElMessage } from 'element-plus'
// 与用户验证相关的方法
const key = 'identity'
// 路由守卫与 http 拦截器共享的跳转锁，防止并发 401 或守卫与拦截器同时触发导航
export let isRedirectingToLogin = false
export function setRedirectingToLogin(val) {
  isRedirectingToLogin = val
}
/**
 * 获取用户token
 */
export function getToken() {
  // 从localStorage获取token
  return localStorage.getItem(`${key}_token`)
}

export function setToken(token) {
  // 本地缓存存储token
  localStorage.setItem(`${key}_token`, token)
}

export function removeToken() {
  // 本地缓存移除token
  localStorage.removeItem(`${key}_token`)
}

export function getUserId() {
  // 从localStorage获取userId
  return localStorage.getItem(`userId`) || ''
}

export function getEnterpriseId() {
  let idKey = localStorage.getItem('enterpriseId')
  let CCProjectFlag = localStorage.getItem('CCProjectFlag')
  if (!idKey && CCProjectFlag === '1') {
    // ElMessage.error('')
    // setTimeout(() => {
    window.close()

    // }, 3000)
  }
  return idKey || ''
  // idKey = idKey.replaceAll(/\s/g, '+')
  // idKey = idKey.replace(/\s+/g, '+')
  // console.log(idKey)
  // let key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
  // const bytes = CryptoJS.AES.decrypt(idKey, 'abcdefgabcdefg12')
  // console.log(bytes)
  // const enterpriseId = bytes.toString(CryptoJS.enc.Utf8)

  // const key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
  // const iv = CryptoJS.enc.Utf8.parse('jskey_1618823712')
  // let srcs = CryptoJS.enc.Utf8.parse(idKey)
  // const encrypted = CryptoJS.AES.decrypt(srcs, key, {
  //   iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7
  // })
  // let enterpriseId = encrypted.toString(CryptoJS.enc.Utf8)

  // const key = '6f4ff1fc2b53b9ee'
  // const iv = 'jskey_1618823712'

  // function decrypt(k, i, str) {
  //   try {
  //     const key = CryptoJS.enc.Utf8.parse(k)
  //     const iv = CryptoJS.enc.Utf8.parse(i)
  //     let base64 = CryptoJS.enc.Base64.parse(str)
  //     let src = CryptoJS.enc.Base64.stringify(base64)
  //     const encrypted = CryptoJS.AES.decrypt(src, key, {
  //       iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.ZeroPadding
  //     })
  //     return encrypted.toString(CryptoJS.enc.Utf8)
  //   } catch (e) {
  //     console.log(e)
  //     return ''
  //   }
  // }

  // let eid = decrypt(key, iv, idKey)
  // return eid ? eid.trim() : idKey

  // console.log('id', enterpriseId)
  // return enterpriseId
  // return idKey
}
